import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import * as SelectHelper from 'util/SelectHelper';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

//const {id} = useParams();

const getJobTypes = (state, props) => state.referenceData.jobTypes;
const getRouteJobTypeId = (state, id) => {
  return id; // Ensure it's returning the id correctly
};



export const getJobTypeById = createSelector(
  getJobTypes,(state, id) => id,
  getRouteJobTypeId,
  (jobTypes, jobTypeId) => {
    var isThere =  jobTypes.find(jobType => jobType.id === jobTypeId);
    return isThere;
  }
);


const getCurrentJob = (state) => {
  const currentJob = state.currentJob;
  return currentJob;
};

const getContacts = state => (state&&state.referenceData&&state.referenceData.contacts)?state.referenceData.contacts:state.contacts?state.contacts:state;
const getAreaId = (state, areaId) => areaId?areaId:null
const getNoticeKey = (state, areaId, noticeKey) => noticeKey?noticeKey:null;


const getAreaId1 = (contacts,areaId)=>{
  return areaId
}

export const getContactsByAreaId = createCachedSelector(
  getContacts,
  getAreaId,
  (contacts, areaId) => {
    return SelectHelper.getContactsByAreaId(contacts, areaId);
  }
)((state, areaId) => areaId);

export const getDefaultContactsByNoticeKey = createCachedSelector(
  getContactsByAreaId,
  getNoticeKey,
  (contacts, noticeKey) =>{
    return SelectHelper.getDefaultContactsByNoticeKey(contacts, noticeKey);
  }
)((state, areaId, noticeKey) => noticeKey);

const getCurrentJobState = (state, props) =>
  state.currentJob ? state.currentJob.currentState :state.currentState//console.log('statehere',state);

export const getDefaultSendNoticeOfIntentionValue = createSelector(
  getCurrentJobState,
  currentJobState => {
    const isNewJob = !currentJobState || currentJobState === 'new';
    return isNewJob;
  }
);

export const getDefaultSendNoticeOfCompletion = createSelector(
  getCurrentJobState,
  currentJobState => {
    const isInProgress = !currentJobState || currentJobState === 'in progress';
    return isInProgress;
  }
);
